<div @show class="body" [formGroup]="formGroup">

    <div class="notifications-wrapper">

        <div *ngIf="!toggled">

            <div class="add-notification-wrapper" [matMenuTriggerFor]="typeMenu">

                <mat-icon class="icon">add</mat-icon>
    
                <span>
                    Neu
                </span>
    
                <span class="counter">
                    {{notificationsArray.controls.length}}
                </span>
    
            </div>
    
            <ng-container *ngIf="notificationsArray.length > 0; else noNotifications">
    
                <ng-container formArrayName="notifications">
    
                    <div *ngFor="let condition of notificationsArray.controls; let i = index" class="notification-wrapper" (click)="setNotificationIndex(i)">
    
                        <app-notification-task-preview [formGroupName]="i" (deleteEmitter)="deleteNotificationAtIndex(i)"></app-notification-task-preview>
    
                    </div>
    
                </ng-container>
    
            </ng-container>

        </div>

        <div class="toggler">

            <button mat-icon-button (click)="toggled = !toggled">
                <mat-icon>
                    {{toggled? 'chevron_right': 'chevron_left'}}
                </mat-icon>
            </button>

        </div>

    </div>

    <div class="notification-content">

        <ng-container #notificationContentOutlet></ng-container>

    </div>

</div>

<mat-menu #typeMenu="matMenu">
    <button mat-menu-item (click)="addEMail()">
        E-Mail
    </button>
    <button mat-menu-item (click)="addInternalMessage()">
        Nachricht im AMS
    </button>
</mat-menu>

<ng-template #noNotifications>

    <div class="centered">

        <div class="spacer"></div>
        <div class="hint">
            Es werden keine Benachrichtigungen ausgelöst
        </div>
        <div class="spacer"></div>

    </div>

</ng-template>

<ng-template #notificationContent>

    <div class="body" [formGroup]="formGroup">

        <div formArrayName="notifications">

            <app-notification-content [formGroupName]="selectedIndex" [issueTemplate]="issueTemplate"></app-notification-content>
    
        </div>

    </div>
    
</ng-template>

<ng-template #noNotificationSelected>

    <div class="centered">

        <div class="spacer"></div>
        <div class="hint">
            Keine Benachrichtigung zum Anzeigen
        </div>
        <div class="spacer"></div>

    </div>

</ng-template>